// apps/admin/src/services/ValidationService.ts
import { functions } from '../firebaseConfig';
import { httpsCallable } from 'firebase/functions';
import type { ValidationStatus, ValidationMetrics, RebuildRequest } from '../types/validation';

export class ValidationService {
  static async getValidationStatus(companyId?: string): Promise<ValidationStatus[]> {
    try {
      const callable = httpsCallable<{ companyId?: string }, ValidationStatus[]>(
        functions,
        'getValidationStatus'
      );
      const result = await callable({ companyId });
      return result.data;
    } catch (error: any) {
  // console.error('[ValidationService] getValidationStatus error:', error);
      throw new Error(error.message || 'Failed to fetch validation status');
    }
  }

  static async getValidationMetrics(): Promise<ValidationMetrics> {
    try {
      const callable = httpsCallable<void, ValidationMetrics>(
        functions,
        'getValidationMetrics'
      );
      const result = await callable();
      return result.data;
    } catch (error: any) {
  // console.error('[ValidationService] getValidationMetrics error:', error);
      throw new Error(error.message || 'Failed to fetch validation metrics');
    }
  }

  static async triggerManualRebuild(request: RebuildRequest): Promise<{ success: boolean; duration: number }> {
    try {
      const callable = httpsCallable<RebuildRequest, { success: boolean; duration: number }>(
        functions,
        'triggerManualRebuild'
      );
      const result = await callable(request);
      return result.data;
    } catch (error: any) {
  // console.error('[ValidationService] triggerManualRebuild error:', error);
      throw new Error(error.message || 'Failed to trigger rebuild');
    }
  }
}